/*=================================================
    summary: 筆記 編輯視窗

    remarks: 000 Tim 2021/12/06 Create
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssNoteEdit from './NoteEdit.module.scss'

// import LoadingMask from '../../Windows/LoadingMask'
import {LoadingMask, GlobalLibs, NetworkLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrDisplayName = ""
let mstrOriginalNoteMessage = ""
// #endregion Member Variables

// #region Const
const MAX_NOTE_CHARACHERS = 512 // Textarea最大的數字限制
// #endregion Const

const COMP_NAME = "NoteEdit"

function NoteEdit(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [noteMessage, setNoteMessage] = useState("")

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrDisplayName = window.Globals.GetDisplayName()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false

            setNoteMessage("")
        }
    }, [props.LessonID, props.LUCatSeqNo])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉 返回 上一個 頁面
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function CloseOnTapHandler(StateNoteMessage)
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        SubmitNote(StateNoteMessage)
    } // end of CloseOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Message 改變 事件
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function MessageChangeHandler(e)
    {
        // console.log(COMP_NAME + ".MessageChangeHandler: e.target.value:", e.target.value)

        setNoteMessage(e.target.value)
    } // end of MessageChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    // #endregion LoadingMask Functions

    // #region Other Functions
    /*===========================================
    summary: 更新 Note資訊後 的 流程
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function ExecuteClose ()
    {   
        console.log(COMP_NAME + ".ExecuteClose")

        let objCallbackData = {
            "Action": "CloseShowNoteEdit"
        }
        props.CallbackRef(objCallbackData)
    } // end of ExecuteClose

    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        mobjCallParam = {
            "BookCatID": props.BookCatID,
            "LessonID": props.LessonID,
            "LUCatSeqNo": props.LUCatSeqNo
        }
        GetNoteInfo()
    } // end of PaintedMe

    /*===========================================
    summary: 發送筆記內容
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function SubmitNote (StateNoteMessage)
    {
        console.log(COMP_NAME + ".SubmitNote")

        let strNoteMessage = StateNoteMessage.trim()

        if (mstrOriginalNoteMessage !== strNoteMessage)
        {
            mobjCallParam = {
                "Note": {
                    "BookCatID": props.BookCatID,
                    "LessonID": props.LessonID,
                    "LUSeqNo": props.LUCatSeqNo,
                    "NoteBody": strNoteMessage
                }
            }
            
            UpdateNote()
        }
        else
        {
            ExecuteClose()
        }
    }  // end of SubmitNote    
    // #endregion Other Functions

    // #region Web Service After Process
    /*===========================================
    summary: 更新 Note資訊後 的 流程
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function UpdateNoteAfterProcess ()
    {   
        console.log(COMP_NAME + ".UpdateNoteAfterProcess")

        mobjCallParam = null

        ExecuteClose()
    } // end of UpdateNoteAfterProcess

    /*===========================================
    summary: 取得Note資訊後 的 流程
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function GetNoteInfoAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetNoteInfoAfterProcess")

        let strNoteMessage = ""
        if (
            (typeof(ReturnData) !== 'undefined') &&
            (ReturnData !== null) &&
            (typeof(ReturnData.Note) !== 'undefined') &&
            (ReturnData.Note !== null) &&
            (typeof(ReturnData.Note.NoteBody) !== 'undefined') &&
            (ReturnData.Note.NoteBody !== null)
            )
        {
            strNoteMessage = ReturnData.Note.NoteBody
        }

        mstrOriginalNoteMessage = strNoteMessage
        setNoteMessage(strNoteMessage)

        mobjCallParam = null
    } // end of GetNoteInfoAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得Note資訊
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function GetNoteInfo ()
    {
        console.log(COMP_NAME + ".GetNoteInfo")

        let objRetryFuncRef = GetNoteInfo
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNoteInfoCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNote)

            let objCallData = {
                "Func": "GetNoteInfo",
                "BookCatID": mobjCallParam.BookCatID,
                "LessonID": mobjCallParam.LessonID,
                "LUSeqNo": mobjCallParam.LUCatSeqNo
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetNoteInfo

    /*===========================================
    summary: 取得Note資訊 Callback
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function GetNoteInfoCallback (Return)
    {
        console.log(COMP_NAME + ".GetNoteInfoCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNoteInfo_No
        let strErrorTitle = window.gAppUI.ERR_GetNoteInfo_Title
        let strErrMsg = window.gAppUI.ERR_GetNoteInfo_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetNoteInfoCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNoteInfoCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNoteInfoCallback Return.Data: ", Return.Data)

            GetNoteInfoAfterProcess(Return.Data)
        }
    } // end of GetNoteInfoCallback

    /*===========================================
    summary: 更新 Note資訊
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function UpdateNote ()
    {
        console.log(COMP_NAME + ".UpdateNote")

        let objRetryFuncRef = UpdateNote
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UpdateNoteCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UpdateNote)

            let objCallData = {
                "Func": "UpdateNote",
                "Note": JSON.stringify(mobjCallParam.Note)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UpdateNote

    /*===========================================
    summary: 更新 Note資訊 Callback
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function UpdateNoteCallback (Return)
    {
        console.log(COMP_NAME + ".UpdateNoteCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UpdateNote_No
        let strErrorTitle = window.gAppUI.ERR_UpdateNote_Title
        let strErrMsg = window.gAppUI.ERR_UpdateNote_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UpdateNoteCallback: ErrNo: ", Return.ErrNo)
            console.log("UpdateNoteCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UpdateNoteCallback Return.Data: ", Return.Data)

            UpdateNoteAfterProcess()
        }
    } // end of UpdateNoteCallback
    // #endregion Web Service

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssNoteEdit.divContent}>
                <label htmlFor="textareaNote" className={cssNoteEdit.divHidden}>
                    {window.gAppUI.LBL_Label}
                </label>
                <textarea id="textareaNote"
                    className={cssNoteEdit.txtNote} 
                    value={noteMessage}
                    maxLength={MAX_NOTE_CHARACHERS}
                    onChange={(event) => MessageChangeHandler(event)}
                />
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {   
        return (
            <div className={cssNoteEdit.divTopTool}>
                <div className={cssNoteEdit.divDisplayName}>
                    {mstrDisplayName}
                </div>

                <div className={cssNoteEdit.divTitle}>
                    {window.gAppUI.LBL_Note}
                </div>

                <div className={cssNoteEdit.btnClose} onClick={() => CloseOnTapHandler(noteMessage)}/>
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssNoteEdit.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper()}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default NoteEdit